import { Module }       from 'vuex';
import { RootState }    from '@/store/store.types';
import state            from '@/views/seasons/store/seasons.state.store';
import actions          from '@/views/seasons/store/seasons.actions.store';
import mutations        from '@/views/seasons/store/seasons.mutations.store';
import { SeasonsState } from '@/views/seasons/seasons.types';

const store: Module<SeasonsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default store;
